import { render } from "./ConversationHistoryChat.vue?vue&type=template&id=466ad23d&scoped=true"
import script from "./ConversationHistoryChat.vue?vue&type=script&lang=js"
export * from "./ConversationHistoryChat.vue?vue&type=script&lang=js"

import "./ConversationHistoryChat.vue?vue&type=style&index=0&id=466ad23d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466ad23d"]])

export default __exports__